import _camelCase from 'lodash/camelCase'
import _cloneDeep from 'lodash/cloneDeep'
import _get from 'lodash/get'
import _has from 'lodash/has'
import _isObject from 'lodash/isObject'
import _isString from 'lodash/isString'
import _set from 'lodash/set'
import _snakeCase from 'lodash/snakeCase'
import _startCase from 'lodash/startCase'
import _startsWith from 'lodash/startsWith'
import _transform from 'lodash/transform'

import { truncateSentence } from '../string/format'

function isFormData(obj: Any) {
  if (!_isObject(obj)) {
    return false
  }
  const name = _get(obj, 'constructor.name')

  return name === 'FormData'
}

export function objectToCamelCase(
  obj: Any,
  { ignoreKeys = [] }: { ignoreKeys?: string[] } = {}
) {
  if (!_isObject(obj) || isFormData(obj)) {
    return obj
  }

  return _transform(
    _cloneDeep(obj),
    function convertCase(result: AnyObject, val: Any, key: string) {
      let finalKey: string
      if (_startsWith(key, '_')) {
        finalKey = key
      } else if (ignoreKeys.includes(key)) {
        finalKey = key
      } else {
        finalKey = _camelCase(key)
      }

      result[finalKey] = _isObject(val) ? objectToCamelCase(val, { ignoreKeys }) : val
    }
  )
}

export function objectToSnakeCase(
  obj: Any,
  { ignoreKeys = [] }: { ignoreKeys?: string[] } = {}
) {
  if (!_isObject(obj) || isFormData(obj)) {
    return obj
  }

  return _transform(
    _cloneDeep(obj),
    function convertCase(result: AnyObject, val: Any, key: string) {
      let finalKey

      if (ignoreKeys.includes(key)) {
        finalKey = key
      } else if (_isString(key) && (key || '').includes('_')) {
        finalKey = key
      } else {
        finalKey = _snakeCase(key)
      }

      result[finalKey] = _isObject(val) ? objectToSnakeCase(val, { ignoreKeys }) : val
    }
  )
}

export function truncatePayload(obj: Any, limit: number): Any {
  if (!_isObject(obj)) {
    return _isString(obj) ? truncateSentence(obj, limit) : obj
  }

  function recursiveTruncate(result: AnyObject, val: Any, key: string) {
    if (_isString(val)) {
      result[key] = truncateSentence(val, limit)
    } else if (_isObject(val)) {
      // Recursively truncate strings in nested objects/arrays
      result[key] = _transform(_cloneDeep(val), recursiveTruncate)
    } else {
      result[key] = val
    }
  }

  return _transform(_cloneDeep(obj), recursiveTruncate)
}

export function getSnakeCaseKey(key: string) {
  if (!_isString(key)) {
    return _snakeCase(key)
  }
  return key.split('.').map(_snakeCase).join('.')
}

export function getCamelCaseKey(key: string) {
  if (!_isString(key)) {
    return _camelCase(key)
  }
  return key.split('.').map(_camelCase).join('.')
}

export function multiCaseHas(obj: Any = {}, key: string = '') {
  return _has(obj, key) || _has(obj, getSnakeCaseKey(key)) || _has(obj, getCamelCaseKey(key))
}

export function multiCaseGet(obj: Any = {}, key: string = '', defaultValue = undefined) {
  if (!multiCaseHas(obj, key)) {
    return defaultValue
  }

  return (
    _get(obj, key) ||
    _get(obj, getSnakeCaseKey(key)) ||
    _get(obj, getCamelCaseKey(key), defaultValue)
  )
}

export function multiCasePick(obj = {}, keys: string[] = []) {
  const result: AnyObject = {}

  for (const key of keys) {
    if (multiCaseHas(obj, key)) {
      _set(result, key, multiCaseGet(obj, key))
    }
  }

  return result
}

export function toTitleCase(str: string) {
  return _startCase(str.replace(/[._-]/g, ' '))
}
